<ion-card class="pending-card">
    <ion-grid fixed [ngClass]="{ 'program-grid-expanded': newBooking }" class="application-grid">
        <ion-row>
            <ion-col size="4" size-xs="0" size-sm="0" size-md="0" size-lg="0" size-xl="4" id="desktop-program-images-col">
                <swiper-container [pagination]="true" [initialSlide]="sliderOpts.initialSlide" [speed]="sliderOpts.speed" [scrollbar]="sliderOpts.scrollbar" [slidesPerView]="sliderOpts.slidesPerView" [centeredSlides]="sliderOpts.centeredSlides" *ngIf="application?.program?.image.length > 0">
                    <swiper-slide *ngFor="let image of images">
                        <img class="program-image" [src]="image | img : application?.program?.state : 'md'" />
                    </swiper-slide>
                </swiper-container>
                <swiper-container [initialSlide]="sliderOpts.initialSlide" [speed]="sliderOpts.speed" [scrollbar]="sliderOpts.scrollbar" [slidesPerView]="sliderOpts.slidesPerView" [centeredSlides]="sliderOpts.centeredSlides" *ngIf="application?.program?.image.length === 0">
                    <swiper-slide>
                        <img class="program-image" [src]="application?.program?.image | img : application?.program?.state : 'md'" />
                    </swiper-slide>
                </swiper-container>
            </ion-col>
            <ion-col size="12" size-xs="12" size-sm="12" size-md="12" size-lg="12" size-xl="6" color="light-teal">
                <div class="more-actions-container">
                    <ion-button class="more-actions-button" fill="clear" color="secondary" (click)="moreActions($event)">
                        <ion-icon slot="icon-only" name="menu-outline"></ion-icon>
                    </ion-button>
                </div>
                <ion-item class="program-mobile-image" lines="none" color="--ion-color-light-teal-2">
                    <ion-thumbnail slot="start" tappable (click)="openPreview(application?.program?.image, 0)" class="mobile-thumbnail-images">
                        <img [src]="application?.program?.image | img : application?.program?.state : 'md'" />
                    </ion-thumbnail>
                    <ion-label class="ion-text-wrap">
                        <ion-text class="mobile-program-name" color="dark-teal">
                            <p>{{ application?.program?.name }}</p>
                            <p style="margin-bottom: 3px">
                                <ion-icon name="pin" size="medium" slot="start" color="secondary"></ion-icon>
                                {{ application?.program?.city }},
                                {{ application?.program?.state }}
                            </p>
                            <p>
                                <ion-icon name="medkit" slot="start" size="medium" color="secondary"></ion-icon>
                                Clinical Experience:
                                {{ application?.program?.exposuretype }}
                            </p>
                        </ion-text>
                    </ion-label>
                </ion-item>
                <ion-list lines="none" class="program-info-card desktop-program-list">
                    <ion-item color="light-teal" style="width: 90%">
                        <ion-label class="program-details-label ion-text-wrap">
                            <ion-text color="dark-teal" class="section-title">
                                {{ application?.program?.name }}
                            </ion-text>
                            <div class="program-title-padding">
                                <ion-text color="dark-teal">
                                    <p>
                                        <ion-icon name="pin" size="medium" slot="start" color="secondary"></ion-icon>
                                        {{ application?.program?.city }},
                                        {{ application.program?.state }}
                                    </p>
                                </ion-text>
                            </div>
                            <div class="program-title-padding">
                                <ion-text color="dark-teal">
                                    <p>
                                        <ion-icon name="medkit" slot="start" size="medium" color="secondary"></ion-icon>
                                        Clinical Experience:
                                        {{ application?.program?.exposuretype }}
                                    </p>
                                </ion-text>
                            </div>
                        </ion-label>
                    </ion-item>
                    <ion-item class="ion-text-center" color="light-teal">
                        <div class="chips-parent">
                            <div class="chips-container" *ngFor="let tag of application?.program?.programtags">
                                <ion-chip [routerLink]="['/search/']" [queryParams]="{ tags: tag }" (contextmenu)="open($event, tag)" class="chip-container"
                                    >{{ tag }}
                                </ion-chip>
                            </div>
                        </div>
                    </ion-item>
                </ion-list>
            </ion-col>
            <!-- Template for right click menu -->
            <ng-template #navMenu let-selectedTab>
                <section>
                    <ion-item class="context-menu" button (click)="openNewTab(selectedTab)">
                        <ion-label>Open in new tab</ion-label>
                    </ion-item>
                </section>
            </ng-template>
        </ion-row>
        <ion-row class="mobile-program-tags">
            <ion-col size="12">
                <ion-item class="ion-text-center" color="light-teal" lines="none">
                    <div class="chips-parent">
                        <div class="chips-container" *ngFor="let tag of application?.program?.programtags">
                            <ion-chip [routerLink]="['/search/']" [queryParams]="{ tags: tag }" class="chip-container">{{ tag }} </ion-chip>
                        </div>
                    </div>
                </ion-item>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col size="10" size-xl="9" sixe-lg="10" size-md="12" size-sm="12" size-xs="12" class="ion-text-right" *ngIf="application?.switchprotectionpaid">
                <ion-badge class="badge-switch-protection">
                    <ion-icon class="icon-switch-protection" name="star"></ion-icon>
                    Switch Protection</ion-badge
                >
            </ion-col>
            <ion-card class="non-booking-card ion-text-center">
                <ion-card-header class="card-header-starttime">
                    <ion-card-title class="ion-text-center">
                        <div class="application-starttime bold-text">
                            {{ application?.type }}<br />
                            <span class="note-text"
                                >{{ application?.startdate | date : 'longDate' : 'UTC' }}
                                -
                                {{ application?.enddate | date : 'longDate' : 'UTC' }}</span
                            >
                        </div>
                    </ion-card-title>
                </ion-card-header>
                <div *ngIf="expandNonBookingCard">
                    <ion-item lines="none" class="payment-header ion-text-center">
                        <ion-label color="text" style="font-weight: 600; font-size: 1.2em">Pay your down payment!</ion-label>
                    </ion-item>
                </div>
                <ion-card-content
                    *ngIf="
                        application?.madedeposit &&
                        application?.signedcontract &&
                        !application?.madepayment &&
                        !application?.madefullpayment &&
                        application?.states !== 'Accepted'
                    "
                    class="card-content"
                >
                    <ion-item lines="none" class="booking-copy" *ngIf="!expandNonBookingCard">
                        <ion-label *ngIf="!(isLate$ | async)" class="ion-justify-content-center ion-text-wrap">
                            <div class="small-box note-text text-teal center-block">
                                <span class="bold-text highlight"
                                    >Your final payment and required documents are due before {{ date$ | async | date : 'longDate' : 'UTC' }}</span
                                ><br /><br />
                                Failure to submit all requirements before the deadline will result in a delay in your start date or a cancellation without
                                refund.
                            </div>
                            <br />
                            <div class="small-box small-text text-teal center-block">
                                <fa-icon [icon]="icons?.exclamation" class="teal"></fa-icon>
                                You have
                                <span class="bold-text highlight">{{ remain$ | async }} days left</span>
                                before the deadline to make your final payment and upload all required documents.
                            </div>

                            <p class="ion-text-center" *ngIf="application?.pendingWiretransfer">Pending Wiretransfer</p>
                        </ion-label>
                        <ion-label *ngIf="isLate$ | async" class="ion-text-center ion-text-wrap">
                            <span class="bold-text highlight">Your final payment is past due.</span>
                            <p style="padding: 10px">
                                <ion-badge color="danger">${{ lateFee$ | async }} USD</ion-badge>
                            </p>
                        </ion-label>
                    </ion-item>
                    <div *ngIf="expandNonBookingCard">
                        <div class="price-breakdown">
                            <p>${{ application?.deposit }} USD</p>
                        </div>
                        <div>
                            <ion-label class="bold-text price-text">${{ application?.deposit }} USD</ion-label>
                        </div>
                        <hr />
                    </div>
                    <ion-button
                        type="button"
                        [queryParams]="{
                            applicationid: application?.id,
                            type: 'final-payment'
                        }"
                        [routerLink]="['/payment/']"
                        routerDirection="'root'"
                    >
                        Make your final payment
                    </ion-button>
                    <br />
                    <div *ngIf="hideButton | async">
                        <p class="cancel-text">Not ready to pay yet?</p>
                        <ion-button fill="clear" type="button" (click)="cancelPayment()" color="primary" class="cancel-link">Go back</ion-button>
                    </div>
                </ion-card-content>
                <div
                    *ngIf="
                        (application?.program?.requiredpostdocumentlist?.requireContract && !application?.signedcontract) ||
                        (application?.program?.requiredpostdocumentlist?.default && !application?.signedcontract)
                    "
                >
                    <ion-card-content *ngIf="(application?.madedeposit || application?.madefullpayment) && !application?.signedcontract" class="card-content">
                        <ion-item lines="none" class="booking-copy">
                            <ion-label class="ion-justify-content-center ion-text-wrap">
                                <div class="small-box not e-text text-teal center-block">
                                    Please look over our
                                    <span class="bold-text highlight">Clinical Agreement</span>
                                    and digitally sign it.
                                </div>
                            </ion-label>
                        </ion-item>
                    </ion-card-content>
                </div>
                <div *ngIf="!application?.paidPreApproved">
                    <ion-card-content
                        *ngIf="
                            !application?.madedeposit &&
                            !application?.madepayment &&
                            !application?.madefullpayment &&
                            !lastMinute &&
                            application?.states !== 'Pre-Approved'
                        "
                    >
                        <ion-item lines="none">
                            <ion-label class="ion-text-wrap">
                                <div class="note-text text-teal">
                                    Before you can hold your seat and complete the rest of your application,
                                    <span class="bold-text highlight">you must reserve your rotation</span>
                                    by making a payment.
                                </div>
                            </ion-label>
                        </ion-item>
                        <div>
                            <p class="ion-text-center" *ngIf="application?.pendingWiretransfer">Pending Wire Transfer</p>

                            <ion-button
                                type="button"
                                [queryParams]="{
                                    applicationid: application?.id,
                                    type: 'first-payment'
                                }"
                                [routerLink]="['/payment/']"
                                routerDirection="'root'"
                            >
                                Pay and Reserve
                            </ion-button>
                            <br />
                            <div *ngIf="hideButton | async">
                                <div class="function-title orange">
                                    <fa-icon [icon]="icons?.arrow" class="orange"></fa-icon>
                                    Complete your payment process below.
                                    <fa-icon [icon]="icons?.arrow" class="orange"></fa-icon>
                                </div>
                                <br />
                                <p class="cancel-text">Not ready to pay yet?</p>
                                <ion-button fill="clear" type="button" (click)="cancelPayment()" color="primary" class="cancel-link">Go back</ion-button>
                            </div>
                        </div>
                    </ion-card-content>
                </div>
                <ion-card-content *ngIf="!application?.madedeposit && !application?.madepayment && !application?.madefullpayment && lastMinute">
                    <ion-item lines="none" class="booking-copy">
                        <ion-icon name="alert" size="medium" slot="start" class="star" color="primary"></ion-icon>
                        <ion-label class="ion-text-wrap card-text">
                            <p><span class="bold-text">Last Minute:</span> You are reserving last minute - program fees must be paid in full.</p>
                        </ion-label>
                    </ion-item>
                    <div>
                        <ion-button
                            type="button"
                            [queryParams]="{
                                applicationid: application?.id,
                                type: 'first-payment'
                            }"
                            [routerLink]="['/payment/']"
                            [routerDirection]="'root'"
                            *ngIf="!(hideButton | async)"
                            []
                        >
                            Pay ${{ application?.price }} USD
                        </ion-button>
                        <br />
                        <div *ngIf="hideButton | async">
                            <p class="cancel-text">Not ready to pay yet?</p>
                            <ion-button fill="clear" type="button" (click)="cancelPayment()" color="primary" class="cancel-link">Go back</ion-button>
                        </div>
                    </div>
                </ion-card-content>
                <ion-card-content *ngIf="!application?.madedeposit && application?.states === 'Pre-Approved'">
                    <ion-item lines="none">
                        <ion-label class="ion-text-wrap">
                            <div class="note-text text-teal">
                                Before you can hold your seat and complete the rest of your application,
                                <span class="bold-text highlight">you must reserve your rotation</span>
                                by making a payment.
                            </div>
                        </ion-label>
                    </ion-item>
                    <div>
                        <p class="ion-text-center" *ngIf="application?.pendingWiretransfer">Pending Wire Transfer</p>

                        <ion-button
                            type="button"
                            [queryParams]="{
                                applicationid: application?.id,
                                type: 'first-payment',
                                approved: 'true'
                            }"
                            [routerLink]="['/payment/']"
                            [routerDirection]="'root'"
                        >
                            Pay now
                        </ion-button>
                        <br />
                        <div *ngIf="hideButton | async">
                            <div class="function-title orange">
                                <fa-icon [icon]="icons?.arrow" class="orange"></fa-icon>
                                Complete your payment process below.
                                <fa-icon [icon]="icons?.arrow" class="orange"></fa-icon>
                            </div>
                            <br />
                            <p class="cancel-text">Not ready to pay yet?</p>
                            <ion-button fill="clear" type="button" (click)="cancelPayment()" color="primary" class="cancel-link">Go back</ion-button>
                        </div>
                    </div>
                </ion-card-content>
            </ion-card>
        </ion-row>
    </ion-grid>
</ion-card>
